import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app/board-directive'

export function extractApiErrorMessage (error) {
  const data = error && error.response && error.response.data
  if (!data) return 'Ocurrió un error al conectar con el servidor'
  if (typeof data === 'string') return data
  if (data.detail) return data.detail

  const messages = []
  const flatten = (obj, prefix) => {
    Object.keys(obj).forEach(key => {
      const val = obj[key]
      const label = prefix ? `${prefix}.${key}` : key
      if (Array.isArray(val)) {
        val.forEach(v => messages.push(`${label}: ${v}`))
      } else if (val && typeof val === 'object') {
        flatten(val, label)
      } else {
        messages.push(`${label}: ${val}`)
      }
    })
  }
  flatten(data, '')
  return messages.join(' | ') || 'Ocurrió un error al procesar la solicitud'
}

export default {
  async getVotaciones (page = 1, pageSize = 10) {
    const url = `${API_BASE}/votaciones/?page=${page}&page_size=${pageSize}`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      // Maneja tanto arrays directos como objetos con 'results'
      if (Array.isArray(response.data)) {
        return response.data
      }
      return response.data.results || []
    } catch (error) {
      console.error('Error fetching votaciones:', error)
      throw error
    }
  },

  async getVotacion (votacionId) {
    const url = `${API_BASE}/votaciones/${votacionId}/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching votacion:', error)
      throw error
    }
  },

  async createVotacion (votacionData) {
    const url = `${API_BASE}/votaciones/`

    try {
      const response = await axios.post(url, {
        tema: votacionData.tema,
        descripcion: votacionData.descripcion,
        fechaCierre: votacionData.fechaCierre
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error creating votacion:', error)
      throw error
    }
  },

  async registrarVoto (votacionId, miembroId, voto) {
    const url = `${API_BASE}/votaciones/${votacionId}/registrar-voto/`

    try {
      const response = await axios.post(url, {
        miembro_id: miembroId,
        voto: voto
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error registering vote:', error)
      throw error
    }
  },

  async cerrarVotacion (votacionId) {
    const url = `${API_BASE}/votaciones/${votacionId}/cerrar/`

    try {
      const response = await axios.post(url, {}, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error closing votacion:', error)
      throw error
    }
  }
}
